export default __webpack_public_path__ + "static/media/ChevronLeft.04b551d5.svg";